import { Button } from '@tmov/design-system';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import TipoPagamentoEnum from '../../../../../Enum/TipoPagamentoEnum';
import { formatarData } from '../../../../../helpers/data';
import { getDataHorasFomatadaAdd3Hours } from '../../../../../helpers/data-fns';
import {
  formatarMoeda,
  formatarTonelada,
  toTitleCase,
} from '../../../../../helpers/formatador';
import {
  Container,
  CustomModal,
  GridDadosItem,
  GridDadosItemText,
  GridTitle,
  ModalTitle,
} from './styles';

const ModalMaisDetalhes = ({ modalVisible, handleClose, cotacao }) => {
  const handleCancelar = () => {
    handleClose();
  };
  return (
    <>
      <CustomModal
        closable={false}
        visible={modalVisible}
        destroyOnClose={true}
        footer={[
          <Button
            variant="outlined"
            key="fechar"
            onClick={() => handleCancelar()}
            style={{ width: 95, height: 36 }}
          >
            Fechar
          </Button>,
        ]}
      >
        <Container>
          <ModalTitle>Detalhes da Cotação </ModalTitle>

          <GridTitle>
            <GridDadosItemText>Dados gerais</GridDadosItemText>
          </GridTitle>

          <div>
            <Row>
              <GridDadosItem>
                <GridDadosItemText regular>Produto</GridDadosItemText>
                <GridDadosItemText>
                  {toTitleCase(cotacao?.produto_descricao)}
                </GridDadosItemText>
              </GridDadosItem>

              <Col style={{ marginLeft: '30%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>Espécie</GridDadosItemText>
                  <GridDadosItemText>
                    {toTitleCase(cotacao?.especie_descricao)}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>

              <Col style={{ marginLeft: '30%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>Volume</GridDadosItemText>
                  <GridDadosItemText>
                    {formatarTonelada(cotacao?.volume)}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <GridDadosItem>
                <GridDadosItemText regular>Cadência</GridDadosItemText>
                <GridDadosItemText>
                  {formatarTonelada(cotacao?.cadencia)}
                </GridDadosItemText>
              </GridDadosItem>

              <Col style={{ marginLeft: '28.5%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>Início</GridDadosItemText>
                  <GridDadosItemText>
                    {formatarData(cotacao?.inicio_carregamento)}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>

              <Col style={{ marginLeft: '25%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>Fim</GridDadosItemText>
                  <GridDadosItemText>
                    {formatarData(cotacao?.fim_carregamento)}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <GridDadosItem>
                <GridDadosItemText regular>Origem</GridDadosItemText>
                <GridDadosItemText>
                  {toTitleCase(cotacao.cidade_origem_nome)} -{' '}
                  {cotacao.cidade_origem_estado}
                </GridDadosItemText>
              </GridDadosItem>

              <Col style={{ marginLeft: '35%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>Destino</GridDadosItemText>
                  <GridDadosItemText>
                    {toTitleCase(cotacao.cidade_destino_nome)} -{' '}
                    {cotacao.cidade_destino_estado}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>
            </Row>
          </div>

          <GridTitle>
            <GridDadosItemText>Dados do BID</GridDadosItemText>
          </GridTitle>

          <div>
            <Row>
              <GridDadosItem>
                <GridDadosItemText regular>Início do BID</GridDadosItemText>
                <GridDadosItemText>
                  {getDataHorasFomatadaAdd3Hours(cotacao.periodo_inicio)}
                </GridDadosItemText>
              </GridDadosItem>

              <Col style={{ marginLeft: '15%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>Fim do BID</GridDadosItemText>
                  <GridDadosItemText>
                    {getDataHorasFomatadaAdd3Hours(cotacao.periodo_fim)}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <GridDadosItem>
                <GridDadosItemText regular>Pagamento</GridDadosItemText>
                <GridDadosItemText>
                  {TipoPagamentoEnum.getTipoPagamentoLote(
                    cotacao?.tipo_pagamento
                      ? cotacao?.tipo_pagamento
                      : TipoPagamentoEnum.POR_FRETE_CHEIO
                  )}
                </GridDadosItemText>
              </GridDadosItem>

              <Col style={{ marginLeft: '25%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>Valor inicial</GridDadosItemText>
                  <GridDadosItemText>
                    {formatarMoeda(cotacao?.valor_inicial)}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>

              <Col style={{ marginLeft: '27%' }}>
                <GridDadosItem>
                  <GridDadosItemText regular>
                    Incremento mínimo
                  </GridDadosItemText>
                  <GridDadosItemText>
                    {formatarMoeda(cotacao?.incremento_minimo)}
                  </GridDadosItemText>
                </GridDadosItem>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <GridDadosItem>
                <GridDadosItemText regular>
                  Observações gerais
                </GridDadosItemText>
                <GridDadosItemText>
                  {cotacao?.observacao ? cotacao?.observacao : 'Nenhuma'}
                </GridDadosItemText>
              </GridDadosItem>
            </Row>
          </div>

          <GridTitle>
            <GridDadosItemText>Veículos</GridDadosItemText>
          </GridTitle>

          <div>
            <Row>
              <GridDadosItem>
                <GridDadosItemText regular>
                  Veículos permitidos
                </GridDadosItemText>

                {cotacao?.tipos_carretas &&
                  cotacao.tipos_carretas.map(carreta => (
                    <GridDadosItemText key={carreta.id}>
                      {`${toTitleCase(carreta.nome)}`}
                    </GridDadosItemText>
                  ))}

                {cotacao?.tipos_cavalos &&
                  cotacao.tipos_cavalos.map(cavalo => (
                    <GridDadosItemText key={cavalo.id}>
                      {`${toTitleCase(cavalo.nome)}`}
                    </GridDadosItemText>
                  ))}
              </GridDadosItem>
            </Row>
          </div>
        </Container>
      </CustomModal>
    </>
  );
};

ModalMaisDetalhes.propTypes = {
  modalVisible: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  cotacao: PropTypes.shape({
    produto_descricao: PropTypes.string,
    especie_descricao: PropTypes.string,
    volume: PropTypes.number,
    cadencia: PropTypes.number,
    periodo_inicio: PropTypes.string,
    periodo_fim: PropTypes.string,
    inicio_carregamento: PropTypes.string,
    fim_carregamento: PropTypes.string,
    cidade_origem_nome: PropTypes.string,
    cidade_destino_nome: PropTypes.string,
    cidade_destino_estado: PropTypes.string,
    cidade_origem_estado: PropTypes.string,
    tipo_pagamento: PropTypes.number,
    valor_inicial: PropTypes.number,
    incremento_minimo: PropTypes.number,
    observacao: PropTypes.string,
    tipos_carretas: PropTypes.arrayOf(PropTypes.object),
    tipos_cavalos: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

ModalMaisDetalhes.defaultProps = {
  modalVisible: false,
};

export default ModalMaisDetalhes;
